import { PersonalCodeError } from '../config/common';
import { isNumeric } from './ParamsUtil';
import { isValid, parse } from 'date-fns';
const EST_PERSONAL_CODE_LENGTH = 11;
class PersonalCodeValidator {
    static validatePersonalCode(code) {
        let valid = true;
        let error = null;
        if (!code) {
            error = PersonalCodeError.MANDATORY;
        }
        else if (!isNumeric(code)) {
            error = PersonalCodeError.MUST_BE_NUMERIC;
        }
        else if (code.length !== EST_PERSONAL_CODE_LENGTH) {
            error = PersonalCodeError.WRONG_LENGTH;
        }
        if (error !== null) {
            valid = false;
            return { valid, error };
        }
        valid = this.firstNumberValid(code) && this.dateValid(code) && this.checkPersonalCodeCheckSum(code);
        return { valid, error: valid ? null : PersonalCodeError.VALIDATION };
    }
    static firstCharIntVal(code) {
        return parseInt(code.charAt(0), 10);
    }
    static firstNumberValid(code) {
        const intVal = this.firstCharIntVal(code);
        return 0 < intVal && intVal <= 6;
    }
    static dateValid(code) {
        const century = this.getYearHundreds(code);
        const dateStr = code.substr(1, 6);
        return isValid(parse(century + dateStr, 'yyyyMMdd', new Date()));
    }
    static getYearHundreds(code) {
        const intVal = this.firstCharIntVal(code);
        if (intVal <= 2) {
            return '18';
        }
        else if (intVal <= 4) {
            return '19';
        }
        return '20';
    }
    static checkPersonalCodeCheckSum(value) {
        const splitPersonalCode = (value || '0').split('').map(Number);
        return splitPersonalCode[10] === this.getControlNumber(value);
    }
}
Object.defineProperty(PersonalCodeValidator, "getControlNumber", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (code) => {
        const multiplier1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 1];
        const multiplier2 = [3, 4, 5, 6, 7, 8, 9, 1, 2, 3];
        let mod;
        let total = 0;
        for (let i = 0; i < 10; i++) {
            total += Number(code.charAt(i)) * multiplier1[i];
        }
        mod = total % EST_PERSONAL_CODE_LENGTH;
        total = 0;
        if (10 === mod) {
            for (let i = 0; i < 10; i++) {
                total += Number(code.charAt(i)) * multiplier2[i];
            }
            mod = total % EST_PERSONAL_CODE_LENGTH;
            if (10 === mod) {
                mod = 0;
            }
        }
        return mod;
    }
});
export default PersonalCodeValidator;
